import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { withRedux } from "helpers";

const AuthRoute = ({ component: Component, path, platformInfo, hide }) => {
  let {
    status: { user },
  } = platformInfo;

  // console.dir(user);
  let isAnonUser = 0;
  if (user && "tempUser" in user) {
    isAnonUser = user.tempUser;
  }
  // console.log("isAnonUser: " + isAnonUser);
  // let location = useLocation();
  // if (window.drift && window.drift.api) {
  //   if (location.pathname === "/") {
  //     window.drift.api.widget.show();
  //   } else {
  //     window.drift.api.widget.hide();
  //   }
  // }

  // relay invitation param to render accept invitation message
  const userInvitationToken = new URLSearchParams(window.location.search).get(
    "invitationToken"
  );
  const relayParams = userInvitationToken
    ? `/lobby?invitationToken=${userInvitationToken}`
    : "/lobby";

  return (
    <Route
      path={path}
      render={(props) =>
        !user || isAnonUser ? (
          <Component {...props} hide={hide} />
        ) : (
          <Redirect to={relayParams} />
        )
      }
    />
  );
};

export default withRedux(AuthRoute);
